import CryptoJS from "crypto-js";

class CryptoHelper {
  private secretKey: string;

  constructor(secretKey: string) {
    if (!secretKey) {
      throw new Error("Secret key is required");
    }
    this.secretKey = secretKey;
  }

  encrypt(data: any): string {
    if (!data) {
      throw new Error("Data is required for encryption");
    }
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
  }

  decrypt<T>(cipherText: string): T {
    if (!cipherText) {
      throw new Error("Cipher text is required for decryption");
    }
    const bytes = CryptoJS.AES.decrypt(cipherText, this.secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) as T;
  }
}

export default CryptoHelper;